<template>
  <div class="home">
    <div class="imgbox">
      <!-- 最外层div设置为绝对定位 -->
      <div style="position: absolute;">
        <img class="box-img" src="../assets/banner.png">
        <div class="box-font">竞价大厅</div>
      </div>
    </div>
    <article class="newhome" v-cloak style="padding-bottom: 100px;">
      <div style="display: flex;margin-top: 40px;">
        <div>
          <leftmenu :value='type' :list='navlist' @datashow=tableshow></leftmenu>
          <!--登录-->
          <leftlogin :formData.sync="form"></leftlogin>
        </div>
        <div class="ml-border">

          <div v-for="(item, index) in this.tenders">
            <div v-show="convertDateFromString(item.JEndTime) > new Date()">
            <div>
              <div style="display: flex;padding: 10px;justify-content: space-between;">
                <p style=" font-weight: bold;">
                  {{ item.Title }} 合同包 {{ item.Childlist[0].PackNum }}
                </p>
                <div style='color:#ff0000;padding-right: 50px;'>
                  <span v-if="convertDateFromString(item.JEndTime) < new Date()">已过期</span>
                  <span style="color: black;" v-else>竞价中</span>
                </div>
                <div style='color:#ff0000;padding-right: 50px;'>
                  <span>报价方式： {{ item.QuoteType == 1 ? '单次报价' : '多次报价'  }}</span>
                </div>
              </div>
            </div>
            <el-table :data="item.Childlist" border style="font-size: 16px;" :row-style="{}"
              :cell-style="{ 'font-size': '14px' }" :header-row-style="{}" :fit="true">
              <el-table-column prop="Option" label="细项">
              </el-table-column>
              <el-table-column prop="Name" label="采购项目名称">
              </el-table-column>
              <el-table-column prop="Brand" label="品牌">
              </el-table-column>
              <el-table-column prop="StartPrice" label="竞价起标价">
              </el-table-column>
              <el-table-column label="竞价价格" width="350px">
                <template slot-scope="scope">
                  <div style='color:#ff0000;'>
                    <span v-if="convertDateFromString(item.JEndTime) < new Date()">已过期不能竞价</span>
                    <div v-else >
                      <el-form style="padding-right: 0px !important">
                        <div v-show="(item.QuoteType == 1 && !scope.row.Price) || !scope.row.Price || item.QuoteType > 1">
                        <el-col >
                          <el-form-item style="margin-bottom: 0px;"  :label="item.ShowBiddingType ==1 ? '价格（元）': '价格（%）'"  ><el-input size="medium"
                              placeholder="请输入价格"  v-model="scope.row.jiage" type="number"></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col>
                          <el-form-item style="margin-bottom: 0px;" label="品牌：" >
                            <el-input size="medium" placeholder="请输入品牌" v-model="scope.row.pinpai"></el-input></el-form-item>
                        </el-col>
                        <el-col >
                          <el-form-item style="margin-bottom: 0px;" label="备注：" >
                            <el-input size="medium" placeholder="请输入备注" v-model="scope.row.beizhu"></el-input></el-form-item>                            
                        </el-col>
                        <el-col>
                            {{ scope.row.UploadFiles ? '投标文件：'+scope.row.UploadFiles : ''}}  {{ scope.row.UploadFilesTime ? '上传时间：' + scope.row.UploadFilesTime: ''  }}
                            <!-- <el-upload class="upload-demo" action="/api/uploadfile/baoming" 
                              :on-remove="handleRemove" :on-success="(response,file,filelist)=> handleAvatarSuccess(item[0], response,file,filelist)" name="Files" :limit="1"
                              :file-list="fileList" accept = ".pdf,.zip,.rar">
                              <el-button size="small" type="primary">上传投标文件</el-button>
                              <div slot="tip" class="el-upload__tip" style="font-size: 14px;">(支持上传文件的格式：pdf|zip|rar，单个文件最大支持50M，超过请联系工作人员。)</div>
                            </el-upload> -->
                            <el-upload  class="upload-demo"
                              action="" 
                              ref="Pic_Upload_1"                    
                              :http-request ="(params) =>Pic_Upload_1(params,scope.row,fileList)"
                              :on-remove="handleRemove"                                  
                              name="Files"
                              accept = ".pdf,.zip,.rar"
                              :limit="1"
                              :file-list="fileList">
                            <el-button size="small" type="primary">上传报价文件（必填）</el-button>
                          <div slot="tip" class="el-upload__tip">(支持上传文件的格式：pdf|zip|rar，单个文件最大支持50M，超过请联系工作人员。)</div>
                        </el-upload>
                      </el-col>
                      <el-col>
                          <el-button type="primary" plain style="margin-top: 5px;" @click="submit(scope.row, item.Id)">{{ scope.row.Price ? '再次竞价' : '提交' }}</el-button>
                        </el-col>
                      </div>
                        <div v-show="scope.row.Price">
                          <el-col :span="10">
                            <el-form-item style="margin-bottom: 0px;">上次价格：{{ scope.row.Price }}</el-form-item>
                          </el-col>
                          <el-col :span="10">
                            <router-link :to="'/Biddinglist?id='+scope.row.Id" style="line-height: 40px;position: relative;font-size: 16px;color: #409EFF;">历史竞价</router-link>
                          </el-col>
                      </div>
                      </el-form>
                    </div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          </div>
        </div>
      </div>
    </article>
  </div>
</template>
<script>
import leftmenu from "../components/leftmenu.vue";
import leftlogin from "../components/leftlogin.vue";
export default {
  name: "Bidding",
  components: { leftmenu, leftlogin },
  data: function () {
    return {
      type: 3,
      Id: 0,
      navlist: [{ Word_Text: '个人资料', Word_Value: 1, Id: 1 },
      { Word_Text: '竞价报名', Word_Value: 2, Id: 2 },
      { Word_Text: '竞价大厅', Word_Value: 3, Id: 3 },
      { Word_Text: '竞价历史', Word_Value: 4, Id: 4 }
      ],
      tenders: [],
      form: {},
      fileList: []
    };
  },
  updated() {
  },
  created() {
    var that = this;
    that.getData();
    const now = new Date();
    console.log(now)
  },
  watch: {
    $route: async function (to, from) {

    }
  },
  mounted() {

  },
  methods: {
    getData() {
      var that = this;
      that.$api.get("/Bidding/Get", null, r => {        
        that.tenders = r.response; 
        console.log(that.tenders)
      });
    },
    tableshow(item) {
      var that = this;
      if (item.Id == 1)
        that.$router.replace("/UserCenter");
      if (item.Id == 2)
        that.$router.replace("/Enroll");
      if (item.Id == 4)
        that.$router.replace("/BiddingHistory");
      return false;
    },
    convertDateFromString(dateString) {
      if (dateString) {
        var date = new Date(dateString.replace(/-/g, "/"));
        return date;
      }
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },    
    submit(item, TenderId) {
      var that = this;
       if (!item.jiage) {
        that.$message({
              message: "请输入价格!",
              type: "error",
            });
            return;
         }
         if (!item.pinpai) {
          that.$message({
              message: "请输入品牌!",
              type: "error",
            });
            return;
         }
         if (!item.UploadFiles) {
          that.$message({
              message: "请上传报价文件!",
              type: "error",
            });
            return;
         }
        that.$api.post("/Bidding/Post", { TenderId: TenderId, ChildPackId: item.Id, PackNum: item.PackNum, price: item.jiage, Brand: item.pinpai, Remark: item.beizhu, UploadFiles: item.UploadFiles }, data => {
          if (data.success) {
            this.$notify({
              type: "success",
              message: "竞价成功!",
              duration: 3000
            });
            location.reload();
          } else {
            this.$message({
              type: "error",
              message: data.msg,
              showClose: true
            });
          }
        });
    },
    Pic_Upload_1(file,fromData, prop){
      this.importFile(file,fromData)      
    },
    //清空显示列表
    clearShowList (uid) {
        let idx = this.$refs['Pic_Upload_1'].uploadFiles.findIndex(item => item.uid === uid)
        this.$refs.Pic_Upload_1.uploadFiles.splice(idx, 1)
    },
    importFile (file,fromData) {      
      const isAccord = file.file.type === 'pdf' || file.file.type === 'zip' || file.file.type === 'rar';
      if (file.file.size / 1024 / 1024 > 350) {
        this.$message({
              showClose: true,
              message: "上传失败，文件大小请控制在 350M 以内",
              type: 'error'
            })
        this.clearShowList(file.uid);            
        return;
      }
      if (file.file.type == isAccord) {
        this.$message({
              showClose: true,
              message: "文件格式错误",
              type: 'error'
            })
            this.clearShowList(file.uid);            
            return;
      }
      var formData = new FormData()
      formData.append('files', file.file)
      var requestConfig = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
      this.$api.post("/uploadfile/jingjia", formData, res =>{
          if (res.success) {
            this.$notify({
              type: "success",
              message: "上传成功!",
              duration: 3000
            });
            fromData.UploadFiles = res.response
            //this.handleAvatarSuccess(res.response,fromData)
            // this.infoForm.Upload_1 = res.response
          } else {
            this.fileList = []
            this.$message({
              showClose: true,
              message: res.msg,
              type: 'error'
            })
            this.clearShowList(file.uid);
          }
        },requestConfig)
    }
  },
  computed: {

  }
};
</script>

<style>
.ml-border {
  margin-left: 20px;
  width: 100%;
  border: 1px solid #CCCCCC;
}

.frame-border {
  width: 204px;
  border: 1px solid #EEEEEE;
}

.lmenu {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #222222;
  font-size: 18px;
}

.pagination {
  text-align: center;
}
</style>